import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { AbsolutePositioned } from '../../../components/Layout/AbsolutePositioned';
import { DiagonalLine, VerticalLine, HorizontalLine } from '../../../components/Layout/Line';
import { Screen, SplitScreen, SplitScreenContentHolder } from '../../../components/Layout/Screen';
import LineLink from '../../../components/LineLink';
import Title from '../../../components/Title';
import TextBlock from '../../../components/TextBlock';
import { ContentContainer } from '../../../components/Layout/ContentContainer';
import SealAnimation from '../../../components/SealAnimation';

// Assets
import { brandColors, device } from '../../../styles/variables';
import dani from '../../../assets/images/tech-dani.jpg';

const StyledScreen = Screen.extend`
  height: 100%;
  padding: 0 0 50px 0;
  @media ${device.tablet} {
    padding: 0;
  }
`;

const BackgroundSplitScreen = SplitScreen.extend`
  position: relative;
  background: url(${dani});
  background-size: cover;
  background-position: 70% 100%;
  height: 100%;
  display: none;
  @media ${device.tablet} {
    display: inline-block;
  }
`;

const BackgroundOverlay = AbsolutePositioned.extend`
  background: ${brandColors.blue};
  width: 100%;
  height: 100%;
  opacity: 0.7;
`;

const YellowSplitScreen = SplitScreen.extend`
  background: ${brandColors.yellow};
  height: 100%;
  width: 100%;
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  @media ${device.tablet} {
    position: relative;
    display: inline-block;
    width: 50%;
  }
`;

const ContentHolder = AbsolutePositioned.extend`
  width: 100%;
  height: 100%;
`;

const ContentSplitScreen = SplitScreen.extend`
  vertical-align: top;
  position: relative;
  display: block;
  width: 100%;
  float: none;
  @media ${device.tablet} {
    float: right;
    width: 50%;
    height: 100%;
  }
`;

const TextContent = AbsolutePositioned.extend`
  min-width: 350px;
  position: relative;
  margin: 144px 0 0 0;

  @media ${device.tablet} {
    position: absolute;
    top: auto;
    bottom: 100px;
    left: 40px;
    margin: 0;
    min-width: 311px;
  }
  @media ${device.laptop} {
    min-width: 350px;
    left: 50%;
    transform: translate(-50%);
  }
`;

const LineLinkPosition = AbsolutePositioned.extend`
  position: relative;
  @media ${device.tablet} {
    left: 50%;
    transform: translate(-50%);
    position: absolute;
    top: auto;
    bottom: 110px;
  }

  .line-link {
    div {
      background-color: ${brandColors.blue};
      @media ${device.tablet} {
        background-color: ${brandColors.white};
      }
    }
  }
`;

const SealContainer = styled.div`
  position: absolute;
  top: -141px;

  @media ${device.tablet} {
    top: 95px;
    left: 48px;
  }
  @media ${device.laptop} {
    top: 26px;
  }
  @media ${device.laptopL} {
    top: 164px;
  }
`;

const Brochure = () => (
  <StyledScreen>
    <BackgroundSplitScreen>
      <BackgroundOverlay />
      <HorizontalLine />
      <SplitScreenContentHolder direction="right">
        <DiagonalLine />
        <VerticalLine />
      </SplitScreenContentHolder>
    </BackgroundSplitScreen>
    <YellowSplitScreen className="yellow-background" />
    <ContentHolder>
      <ContentContainer>
        <ContentSplitScreen>
          <SealContainer>
            <SealAnimation />
          </SealContainer>
          <TextContent>
            <Title primary={false}>Thinking, writing, making</Title>
            <TextBlock>
              <p>
                We provide creative and strategic input to ensure a clear and concise final brief.
                We&apos;ll then conceptualise and produce the deliverables, involving all
                stakeholders, review and approval systems in an iterative approach, with ongoing
                support.
              </p>
            </TextBlock>
          </TextContent>
        </ContentSplitScreen>
        <ContentSplitScreen>
          <LineLinkPosition>
            <LineLink
              className="line-link"
              linkText="get our creds"
              linkColor={brandColors.orange}
              route="/contact#contactMain"
              lineAnimate
              active
            />
          </LineLinkPosition>
        </ContentSplitScreen>
      </ContentContainer>
    </ContentHolder>
  </StyledScreen>
);

export default connect()(Brochure);



// WEBPACK FOOTER //
// ./src/pages/Services/screens/Brochure.jsx